import { CreateProductTagDto } from './dtos/create-product-tag-dto';

import { IPaginateProducts } from "../../common-dtos/get-all-paginate";
import ApiService from "../../utils/base-api/api-service";
import { ITagProducts } from "./dtos/tag-list";
import { ITagDataProducts } from './dtos/product-tag';
import { ProductTagProductsObjDto } from './dtos/product-tag-products-dto';



class ProductTagService extends ApiService {
    constructor() {
        super({
            baseURL: '/ProductTagsAdmin',
        });
    }
    productTagList(queryPaginate?: IPaginateProducts & { Keyword?: string }): Promise<ITagProducts> {
        return this.post('/List', {}, {
            params: queryPaginate
        });
    }

    getProductTagByID(productTagId: string): Promise<ITagDataProducts> {
        return this.get('/GetProductTagByID', {params: {id: productTagId}});
    }

    getProducts(productTagId: string): Promise<ProductTagProductsObjDto> {
        return this.post(`/Products?tagId=${productTagId}`)    
    }

    createProductTag(input: CreateProductTagDto) {
        return this.post('/Create', input);
    }

    editProductTag(input: CreateProductTagDto) {
        return this.post('/Edit', input);
    }

    deleteProductTag(productTagId: string) {
        return this.post(`/Delete?id=${productTagId}`);
    }
}

export const productTagServices = new ProductTagService();